import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import IdleScreen from "../pages/idle";
import QRScanScreen from "../pages/qr-scan";
import MainScreen from "../pages/main";
import ReleaseScreen from "../pages/release-screen";
import { SocketProvider } from "../context/SocketContext";
import TicketSessionManager from "../components/KioskSessionManager";
import KioskSessionManager from "../compoment/KioskSessionManager";
import GlobalPinHandler from "../compoment/GlobalPinHandler";
import PWAInstallPrompt from "../compoment/PWAInstallPrompt";

const SECRET_KEY = process.env.REACT_APP_RELEASE_ROOM_SECRET_KEY || "";
const PAYMENT_SECRET_KEY = process.env.REACT_APP_KIOSK_SECRET_KEY || "";

const AppRoutes = () => {
  return (
    <SocketProvider
      secretKey={SECRET_KEY}
      paymentSecretKey={PAYMENT_SECRET_KEY}
    >
      <Router>
        <KioskSessionManager />
        <TicketSessionManager />
        <GlobalPinHandler />
        <PWAInstallPrompt />
        <Routes>
          {/* ================= COMMON ROUTE ================= */}
          <Route path="/" element={<IdleScreen />} />
          <Route path="/qr-scan" element={<QRScanScreen />} />
          <Route path="/main" element={<MainScreen />} />
          <Route path="/release" element={<ReleaseScreen />} />
        </Routes>
      </Router>
    </SocketProvider>
  );
};

export default AppRoutes;
